/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import PropTypes from 'prop-types';
import { defaultCurrency } from '../../shared/constants/currency';

import styles from './WidgetItem.module.css';

const getNestedPartProps = (brandRefresh, part) =>
  brandRefresh ? { 'data-part': part } : {};

const formatNestedPrice = (brandRefresh, price, currency) => {
  if (!price) {
    return null;
  }

  if (brandRefresh) {
    const amount = parseFloat(price);
    if (!amount) {
      return null;
    }
    return `(+${currency.symbol}${amount.toFixed(2)})`;
  }

  return `${currency.symbol}${price}`;
};

const WidgetItem = ({
  id,
  amount,
  title,
  type,
  price,
  currency,
  unavailableProducts,
  brandRefresh,
}) => {
  const isUnavailable = !!unavailableProducts.includes(parseInt(id, 10));
  const customContainerClasses = isUnavailable ? `${styles.widgetItemContainer} ${styles.unavailableProduct}` : styles.widgetItemContainer;
  const priceText = formatNestedPrice(brandRefresh, price, currency);
  const nestedTitle = amount != null ? `${amount} ${title}` : title;
  return (
    <div
      className={`
      ${customContainerClasses} 
      flex items-center justify-between md:py-[17px] mb-3
      border-[1px] border-borderLight
      `}
      {...getNestedPartProps(brandRefresh, 'nested-item')}
    >
      <div
        className={`${styles.orderTitle} text-dark dark:text-white`}
        {...getNestedPartProps(brandRefresh, 'nested-item-title')}
      >
        <p>
          {brandRefresh ? nestedTitle : null}
          {brandRefresh ? null : <span>{amount}</span>}
          {brandRefresh ? null : title}
        </p>
      </div>
      <div
        className={`${styles.orderType} text-dark dark:text-white`}
        {...getNestedPartProps(brandRefresh, 'nested-item-type')}
      >
        {type ? <p>{type.toLowerCase().replace('_',' ')}</p> : undefined}
      </div>
      <div
        className={`${styles.orderPrice} text-dark dark:text-white`}
        {...getNestedPartProps(brandRefresh, 'nested-item-price')}
      >
        {priceText ? <p>{priceText}</p> : undefined}
      </div>
    </div>
  );
};

WidgetItem.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  price: PropTypes.oneOfType( [
    PropTypes.number, 
    PropTypes.string
   ]),
  currency: PropTypes.shape({
    symbol: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unavailableProducts: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  brandRefresh: PropTypes.bool,
};

WidgetItem.defaultProps = {
  amount: null,
  type: null,
  price: null,
  currency: defaultCurrency,
  id: null,
  unavailableProducts: [],
  brandRefresh: false,
}


export default WidgetItem;
